import { atom } from 'recoil';
import { DateTime } from 'luxon';
import { DatePickerUtils } from '@sparrow-marketing/storybook';
import { Utils } from '@sparrow-marketing/contracts/';

import { LOCAL_STORAGE_TYPES, PERIOD_OPTIONS } from '../../constants';
import { IInsights } from './types';
import { useDateFormatPeriod } from '../../hooks/use-date-format-period';

const insightsInitialState: IInsights[] = [];
const selectedInsights = {};

export const initialStartDate = DateTime.local()
  .minus({ days: 28 })
  .toFormat('yyyy-MM-dd');
export const initialEndDate = DateTime.local()
  .minus({ day: 1 })
  .toFormat('yyyy-MM-dd');

// eslint-disable-next-line react-hooks/rules-of-hooks
const { getPeriodFormatted } = useDateFormatPeriod();

const localWorkspaceData = localStorage.getItem(LOCAL_STORAGE_TYPES.WORKSPACE);
let initStartDate = initialStartDate;
let initEndDate = initialEndDate;
let initPeriod = PERIOD_OPTIONS.last28Days;
if (localWorkspaceData) {
  const parsedData = JSON.parse(localWorkspaceData);
  if (parsedData?.period && !/custom/gi.test(parsedData.period)) {
    const { start, end, period } = getPeriodFormatted(parsedData.period);
    initStartDate = start;
    initEndDate = end;
    initPeriod = period;
  } else if (
    parsedData?.start &&
    parsedData?.end &&
    /custom/gi.test(parsedData.period)
  ) {
    initStartDate = parsedData.start;
    initEndDate = parsedData.end;
    initPeriod = DatePickerUtils.checkPeriod(initStartDate, initEndDate);
  }
  const updatedLocalStorage = {
    ...parsedData,
    start: initStartDate,
    end: initEndDate,
    period: initPeriod,
  };
  localStorage.setItem(
    LOCAL_STORAGE_TYPES.WORKSPACE,
    JSON.stringify(updatedLocalStorage)
  );
}

export const InsightsState = atom<IInsights[]>({
  key: 'insights',
  default: insightsInitialState,
});

export const SelectedInsightsState = atom<any>({
  key: 'selected-insights',
  default: selectedInsights,
});

export const SelectedAccountId = atom<Utils.DynamicObject>({
  key: 'selected-accountId',
  default: {
    social: '',
    ads: '',
    email: '',
    website: '',
  },
});

export const IsLoader = atom<boolean>({
  key: 'is-loader',
  default: false,
});

export const IsChartLoading = atom<boolean>({
  key: 'is-chart-loading',
  default: false,
});

export const InsightsDateRange = atom<any>({
  key: 'insight-date-range',
  default: { start: initStartDate, end: initEndDate, period: initPeriod },
});

export const OldInsightsState = atom<any>({
  key: 'old-insight',
  default: [],
});

export const InsightAccountLoader = atom<Utils.DynamicObject>({
  key: 'insights-account-loader',
  default: {},
});
